import React from "react";
import { Input, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";

export default function SearchBox({ value, onChange, placeholder = "Ara..." }) {
  return (
    <InputGroup className="mb-3">
      <InputGroupAddon addonType="prepend">
        <InputGroupText>
          <i className="fas fa-search" />
        </InputGroupText>
      </InputGroupAddon>
      <Input
        type="text"
        placeholder={placeholder}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      />
    </InputGroup>
  );
}
